import { AxiosRequestConfig } from 'axios';

export const getUserPanelData = (): AxiosRequestConfig => ({
   url: `/mx/v1/app/info/general`,
   method: 'get',
});
